import dayjs from 'dayjs'

const $str = window.$str;

const chartColors = ['#4960FF', '#0CD5FF', '#2DFFAA', '#FFA441', '#944DFF', '#EE3CD3', '#FF532D', '#0DE24A']
const lineColor = "#3e4961"; // 图表splitLine的颜色
const textColor = "#000000"; // 图表文字的颜色

const defaultMin = dayjs().format('YYYY-MM-DD 00:00:00');
const defaultMax = dayjs().format('YYYY-MM-DD 23:59:59');


export function getChartOption(chartData = [], start = defaultMin, end = defaultMax) {
  const { yMin, yMax } = getYaxisRange(chartData);
  const option = {
    color: chartColors,
    grid: [
      {
        top: 40,
        left: 40,
        right: 10,
        bottom: 80
      },
    ],
    xAxis: [
      {
        gridIndex: 0,
        type: 'time',
        min: start,
        max: end,
        name: $str.getKey('数据分析/时间'), // 轴线名称
        nameLocation: 'end',
        nameTextStyle: {
          color: textColor
        },
        axisLabel: {
          color: textColor,
          formatter(value) {
            return dayjs(value).format("YYYY-MM-DD HH:mm:ss").replace(/\s/, '\n'); // 格式化时间格式&折行显示
          },
        },
        boundaryGap: false, // 坐标轴两边留白策略。时间轴，该值是一个两个值的数组，表示数据最小值和最大值的延伸范围，数值或%，在设置 min 和 max 后无效。
        // boundaryGap: ['10%', '10%'], // 在数据最小值的左侧，坐标轴预留10%的空间不展示数据。在数据最大值的右侧，坐标轴预留10%的空间不展示数据。
        axisLine: { // 坐标轴轴线的配置
          // onZero: true, // 轴线是否在另一个轴的 0 刻度上，只有在另一个轴为数值轴且包含 0 刻度时有效。
          lineStyle: {
            color: lineColor
          }
        },
        position: 'bottom', // 轴线展示位置
      },
    ],
    yAxis: [
      {
        gridIndex: 0,
        name: $str.getKey('数据分析/电压(mV)'),
        type: 'value',
        // min: 2400,
        // max: 3600,
        max: yMax,
        min: yMin,
        nameLocation: 'end',
        nameTextStyle: {
          align: 'center',
          color: textColor,
          padding: [0, 0, 0, 35]
        },
        type: 'value',
        splitLine: {
          lineStyle: {
            color: '#eee',
            type: 'dashed'
          }
        },
        axisLabel: {
          color: textColor,
        },
        axisLine: {
          lineStyle: {
            color: lineColor
          }
        },
        splitNumber: 6 // 设置Y轴默认分割5个段
      },
    ],
    series: createSeries(chartData),
    legend: {
      show: false,
      right: 10,
      icon: 'circle',
      itemWidth: 8,
      textStyle: {
        color: textColor
      }
    },
    tooltip: createTooltip(),
    axisPointer: {
      link: { xAxisIndex: 'all' }, // 鼠标指示器-辅助线，对所有坐标系生效
      label: {
        backgroundColor: '#777' // 鼠标指示器-坐标文字提示的颜色
      }
    },
    dataZoom: [
      {
        height: 12,
        bottom: 8,
        textStyle: {
          color: '#8392A5'
        },
        handleIcon: 'path://M10.7,11.9v-1.3H9.3v1.3c-4.9,0.3-8.8,4.4-8.8,9.4c0,5,3.9,9.1,8.8,9.4v1.3h1.3v-1.3c4.9-0.3,8.8-4.4,8.8-9.4C19.5,16.3,15.6,12.2,10.7,11.9z M13.3,24.4H6.7V23h6.6V24.4z M13.3,19.6H6.7v-1.4h6.6V19.6z',
        dataBackground: {
          areaStyle: {
            color: '#8392A5'
          },
          lineStyle: {
            opacity: 0.8,
            color: '#8392A5'
          }
        },
        brushSelect: true,
        start: 0,
        end: 100,
        xAxisIndex: [0, 1]
      },
      {
        type: 'inside',
        xAxisIndex: [0, 1]
      }
    ]
  }

  return option
}


function getYaxisRange(chartData) {
  const result = {
    yMin: 2400,
    yMax: 3600,
  }
  if (Array.isArray(chartData) && chartData.length > 0) {
    // 自适应计算坐标系1的Y刻度范围 
    chartData.forEach(point => {
      const numArr = Object.values(point).filter(v => !isNaN(v));
      const newMax = Math.max(...numArr);
      const newMin = Math.min(...numArr);

      result.yMax = Math.max(result.yMax, newMax);
      result.yMin = Math.min(result.yMin, newMin);
    })

    const moreRange = (result.yMax - result.yMin) * 0.1;
    result.yMax += moreRange;
    result.yMin -= moreRange;
  }
  return result;
}


function createSeries(chartData = []) {
  const series = [];
  if (Array.isArray(chartData) && chartData.length > 0) {
    const lineDataKeys = Object.keys(chartData[0]).filter(key => key.startsWith('v')).sort((a, b) => {
      return Number(a.replace(/[vV]/g, '')) - Number(b.replace(/[vV]/g, ''));
    });

    lineDataKeys.forEach(key => {
      const lineData = chartData.map(item => {
        const time = dayjs(item.record_time).format('YYYY-MM-DD HH:mm:ss');
        const data = Number(item[key]).toFixed(2);
        return [time, data];
      })
      const serieItem = {
        name: key,
        type: 'line',
        symbol: 'none',
        lineStyle: {
          width: 1,
        },
        data: lineData
      }
      series.push(serieItem);
    })
  }

  series.push({
    xAxisIndex: 0,
    yAxisIndex: 0,
    type: 'line',
    name: $str.getKey('数据分析/电压范围'),
    symbol: 'circle',
    symbolSize: 0,
    markLine: {
      data: [
        {
          name: 'max',
          yAxis: 3600,
          label: {
            formatter: '{b}: {c}'
          }
        },
        {
          name: 'min',
          yAxis: 2400,
          label: {
            formatter: '{b}: {c}'
          }
        },
      ],
      label: {
        show: true,
        position: 'insideEndTop',
        color: 'inherit',
      },
      lineStyle: {
        color: '#2DFFAA'
      }
    },
  })

  return series;
}



function createTooltip(config = {}) {
  const timeFormatter = (value) => {
    // 格式化时间：如果是时间戳，转换为年月日时分秒；如果是时间字符串，直接使用
    let timeValue = value;
    if (typeof timeValue === 'number' || (typeof timeValue === 'string' && /^\d+$/.test(timeValue))) {
      // 判断是否是时间戳（毫秒或秒）
      const timestamp = Number(timeValue);
      const isMillisecond = timestamp > 946684800000; // 2000-01-01的时间戳（毫秒）
      timeValue = dayjs(isMillisecond ? timestamp : timestamp * 1000).format('YYYY-MM-DD HH:mm:ss');
    } else if (timeValue instanceof Date) {
      timeValue = dayjs(timeValue).format('YYYY-MM-DD HH:mm:ss');
    }
    return timeValue;
  };

  return {
    trigger: 'axis',
    axisPointer: {
      type: 'cross'
    },
    className: 'chart-tooltip',
    backgroundColor: 'rgba(255, 255, 255, 0.90)',
    borderWidth: 0,
    textStyle: {
      color: '#6A727C'
    },
    formatter(params) {
      if (params.length > 0) {
        const firstItem = params[0];
        let time = firstItem.axisValue;
        time = timeFormatter(time);

        const maxItem = {
          seriesName: firstItem.seriesName,
          value: Array.isArray(firstItem.data) ? firstItem.data[1] : firstItem.data,
          color: firstItem.color,
        }
        const minItem = {
          seriesName: firstItem.seriesName,
          value: Array.isArray(firstItem.data) ? firstItem.data[1] : firstItem.data,
          color: firstItem.color,
        }
        params.forEach(item => {
          const value = Array.isArray(item.data) ? item.data[1] : item.data;
          if (+value > +maxItem.value) {
            maxItem.seriesName = item.seriesName;
            maxItem.value = value;
            maxItem.color = item.color;
          }
          if (+value < +minItem.value) {
            minItem.seriesName = item.seriesName;
            minItem.value = value;
            minItem.color = item.color;
          }
        })

        return /* html */`
          <div class="chart-tooltip__time" style="margin-bottom: 12px;">${time}</div>
          <div class="chart-tooltip__items-container">
            <div class="chart-tooltip__series" style="display: flex; align-items: center; justify-content: space-between; gap: 8px; line-height: 1.5;">
              <div style="display: flex; align-items: center; gap: 6px; flex: 1;">
                <div class="chart-tooltip__point" style="background: ${maxItem.color}; width: 8px; height: 8px; border-radius: 50%; flex-shrink: 0; display: inline-block; vertical-align: middle;"></div>
                <div class="chart-tooltip__series-name" style="display: inline-block; vertical-align: middle;">${$str.getKey('数据分析/最大值')}</div>
              </div>
              <div class="chart-tooltip__value" style="flex-shrink: 0; display: inline-block; vertical-align: middle; text-align: right;">${maxItem.value} mV</div>
            </div>
            <div class="chart-tooltip__series" style="display: flex; align-items: center; justify-content: space-between; gap: 8px; line-height: 1.5;">
              <div style="display: flex; align-items: center; gap: 6px; flex: 1;">
                <div class="chart-tooltip__point" style="background: ${maxItem.color}; width: 8px; height: 8px; border-radius: 50%; flex-shrink: 0; display: inline-block; vertical-align: middle;"></div>
                <div class="chart-tooltip__series-name" style="display: inline-block; vertical-align: middle;">${$str.getKey('数据分析/最大值电芯')}</div>
              </div>
              <div class="chart-tooltip__value" style="flex-shrink: 0; display: inline-block; vertical-align: middle; text-align: right;">${maxItem.seriesName}</div>
            </div>
            <div class="chart-tooltip__series" style="display: flex; align-items: center; justify-content: space-between; gap: 8px; line-height: 1.5;">
              <div style="display: flex; align-items: center; gap: 6px; flex: 1;">
                <div class="chart-tooltip__point" style="background: ${minItem.color}; width: 8px; height: 8px; border-radius: 50%; flex-shrink: 0; display: inline-block; vertical-align: middle;"></div>
                <div class="chart-tooltip__series-name" style="display: inline-block; vertical-align: middle;">${$str.getKey('数据分析/最小值')}</div>
              </div>
              <div class="chart-tooltip__value" style="flex-shrink: 0; display: inline-block; vertical-align: middle; text-align: right;">${minItem.value} mV</div>
            </div>
            <div class="chart-tooltip__series" style="display: flex; align-items: center; justify-content: space-between; gap: 8px; line-height: 1.5;">
              <div style="display: flex; align-items: center; gap: 6px; flex: 1;">
                <div class="chart-tooltip__point" style="background: ${minItem.color}; width: 8px; height: 8px; border-radius: 50%; flex-shrink: 0; display: inline-block; vertical-align: middle;"></div>
                <div class="chart-tooltip__series-name" style="display: inline-block; vertical-align: middle;">${$str.getKey('数据分析/最小值电芯')}</div>
              </div>
              <div class="chart-tooltip__value" style="flex-shrink: 0; display: inline-block; vertical-align: middle; text-align: right;">${minItem.seriesName}</div>
            </div>
          </div>
        `
      }
      return `<div class="chart-tooltip__items-container">${$str.getKey('数据分析/暂无数据')}</div>`
    }
  }
}


